// import wx from 'weixin-js-sdk'
function onBridgeReady (data) {
  return new Promise((resolve, reject) => {
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        appId: data.appId, //公众号ID，由商户传入
        timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
        nonceStr: data.nonceStr, //随机串
        package: data.package,
        signType: data.signType, //微信签名方式：
        paySign: data.paySign //微信签名
      },
      function(res) {
        let response = {
          status: false,
          cancelPay: false,
          message: '微信支付失败'
        }

        if (!res.err_msg) {
          res.err_msg = res.errMsg
        }

        response.message = res.err_msg
        
        if (res.err_msg.includes('fail')) {
          response.status = false
          response.message = '微信支付失败' + res.err_msg
        }

        if (res.err_msg.includes('cancel')) {
          response.status = false
          response.cancelPay = true
          response.message = '取消微信支付'
        }

        if (res.err_msg.includes('ok')) {
          response.status = true
          response.message = '微信支付成功'
        }

        // if (res.errMsg.includes('fail')) {
        //   response.status = false
        //   response.message = '微信支付失败'
        // }

        resolve(response)
      }
    )
  })
}

function wechatPaybyJssdk(data) {
  if (typeof WeixinJSBridge == 'undefined') {
    if (document.addEventListener) {
      document.addEventListener(
        'WeixinJSBridgeReady',
        () => {
          return onBridgeReady(data)
        },
        false
      )
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', () => {
        return onBridgeReady(data)
      })
      document.attachEvent('onWeixinJSBridgeReady', () => {
        return onBridgeReady(data)
      })
    }
  } else {
    return onBridgeReady(data)
  }
}

export default wechatPaybyJssdk